import React, { Component, useEffect } from 'react';
import {  Grid, Box, TableFooter, Button, Typography, Paper, Link } from '@material-ui/core';
import { Fragment } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';


import { SingleSwitch } from '../../../../../commonModules/MUI/RadioAndCheckbox';
import { useSelector } from 'react-redux';
import SingleTransferQrCode from './SingleTransferQrCode';
import Watermark from './Watermark';

const SingleTransferBody = (props) => {

    // useEffect = () => {
    //     console.log('===============SingleTransferBody=====================');
    //     console.log({props});
    //     console.log('====================================');

    // }
    // const { addFiles, spendingID, spending_id, factExist, addFactures, partDetails } = this.state;
    const { client, shopDest, transfer, agent, commercial, shop, TVAOpt, 
        handleInstallToSale, 
        handleCompleteArrivage, 
        handleUpdateArrivage,
        handleUpdateDemand,
        handleUpdatePurchase,
        handleUpdateRea,
        validateOpt
     } = props;
    // let list = []
    // let total_payed = 0
    // let rest = 0

    // console.log('====================================');
    // console.log(this.state.factList, );
    // console.log( this.state.factList.split(", "));
    // console.log( Object.keys(factExist));
    // console.log('====================================');

    // if(transfer.sale_credit) {
    //     list = this.filterList()
    //     list.forEach(item => total_payed += item.amount)
    //     console.log({list});
    //     rest = transfer.total_price - total_payed
    // }   
     console.log("[DEBUG],transfers",transfer)
    return(
        <>
            {/* {props.localOpt &&
                <Box p={1} style={{ textAlign: "left"}}>
                    <Button color="primary" variant="outlined" onClick={props.handleBL}>Ranger les Articles</Button>
                </Box>
            }
            */}
            {!props.draft &&
                <Box p={1} style={{ textAlign: "right"}}>
                    {props.BLOpt && !props.BL && !(transfer.nature === "quote") &&
                        <Button color="primary" variant="contained" onClick={props.handleBL}>Bon de Livraison</Button>
                    }
                    {props.BLOpt && props.BL &&
                        <Button color="primary" variant="contained" onClick={props.handleBL}>Facture</Button>
                    }
                    {(transfer.nature === "vente") &&
                        <Button color="primary" variant="contained" onClick={props.downloadInvoicePDF}>Download Facture</Button>
                    }
                    {(transfer.nature === "quote") &&
                        <Button color="primary" variant="contained" onClick={props.downloadInvoicePDF}>Download Cotation</Button>
                    }
                    <Button color="secondary" onClick={() => window.print()}>Imprimer</Button>
                </Box>
            }
            {TVAOpt &&
                <Box p={2} >
                    <SingleSwitch
                        color="primary"
                        label="Afficher la TVA"
                        labelPlacement="start"
                        name="TVA" 
                        checked={props.TVA} 
                        onChange={
                            (e) => props.handleCheck(e.target.checked, "TVA")
                        }
                    />
                </Box>
            }
            {handleInstallToSale  &&
                <Box p={2} >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={handleInstallToSale}
                    >
                        Finaliser l'installation
                    </Button>
                </Box>
            }
            {handleCompleteArrivage  && !transfer.received && !(transfer.transfer_type === "demande") &&
                <Box p={2} >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => handleCompleteArrivage(transfer, shop)}
                    >
                        Finaliser l'arrivage
                    </Button>
                </Box>
            }
            
            {handleUpdateDemand && (transfer.transfer_type === "demande") &&
                <Box p={2} >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => handleUpdateDemand(transfer, shop)}
                    >
                        Modifier la demande
                    </Button>
                </Box>
            }
            {handleUpdateArrivage  && !transfer.received && (transfer.transfer_type === "arrivage") &&
                <Box p={2} >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => handleUpdateArrivage(transfer, shop)}
                    >
                        Modifier l'arrivage
                    </Button>
                </Box>
            }
            {handleUpdatePurchase  && !transfer.received && transfer.nature === 'achat' &&
                <Box p={2} >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => handleUpdatePurchase(transfer, shop)}
                    >
                        Modifier l'achat
                    </Button>
                </Box>
            }
            
            {handleUpdateRea &&
                <Box p={2} >
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => handleUpdateRea(transfer, shop)}
                    >
                        Modifier le brouillon
                    </Button>
                </Box>
            }
            
            <div id="section-to-print" style={{padding:"25px 15px 10px"}} >
                <Box>
                    {(transfer.nature != "reservation_demande" && (transfer.is_tmp || (!transfer.received && (transfer.nature == "achat" || transfer.nature == "reapprovisionnement" || transfer.nature == "reapprovisionnement_ext_dest" )))) &&
                        <Watermark text={(transfer.nature == "avoir" ? "FACTURE ANNULÉE": "DOCUMENT PROVISOIRE")} />
                    }
                    {(transfer.is_deleted  && (transfer.nature == "vente")) &&
                        <Watermark text="FACTURE ANNULÉE"/>
                    }
                    {!props.draft &&
                        <SingleTransferQrCode id={transfer.id}>
                            <Box >
                                {shop && transfer.nature != "commercial_return" &&
                                    <Box p={1}>
                                        {shop.logo &&
                                        <Box className="logo">
                                            <img src={`/stocks/photos/${shop.logo.filename}`} alt=""/>
                                        </Box>
                                        }
                                        <Box>
                                            <Typography variant="body1"><b>{shop.name}</b></Typography>
                                            {shop.tel && <Typography variant="body2">{shop.tel} </Typography> }
                                            {shop.email && <Typography variant="body2">{shop.email} </Typography> }
                                            <Typography variant="body2">{shop.address}</Typography>
                                            <Typography variant="body2">{shop.city} - {shop.country}</Typography>
                                        </Box>
                                    </Box>
                                }
                                {agent &&
                                    <Box p={1}>
                                        <Typography variant="subtitle">Vendu par: </Typography>
                                        <Typography variant="body1"><b>{agent.name}</b></Typography>
                                        <Typography variant="body2">{agent.phone && agent.phone.join(" - ")} </Typography>                                    
                                        {agent.email && <Typography variant="body2">{agent.email} </Typography>}
                                        <Typography variant="body2">{agent.company}</Typography>
                                    </Box>
                                }
                                {commercial && transfer.nature == "commercial_return" &&
                                    <Box >
                                        <Typography variant="caption">Commercial : </Typography>
                                        <address>
                                            <Typography variant="body1"><b>{commercial.name}</b></Typography>
                                            <Typography variant="body2">{commercial.phone && commercial.phone.join(" - ")}</Typography>
                                            <Typography variant="body2">{commercial.email}</Typography>
                                        </address>
                                    </Box>
                                }
                            </Box>
                        </SingleTransferQrCode>
                    }

                    <Box m={1} style={{ float: "right", width: "300px"}}>
                                {client &&
                                    <Box p={2} style={{ borderRadius: "5px", background:"#99999945"}}>
                                        <Typography variant="caption">Client : </Typography>
                                        <Typography variant="body1"><b>{client.client_firstname} {(client.client_lastname).toUpperCase()}</b></Typography>
                                        <address>
                                            <Typography variant="body2">{client.client_tel}</Typography>
                                            <Typography variant="body2">{client.client_address}</Typography>
                                            <Typography variant="body2">{client.client_city} - {client.client_country}</Typography>
                                        </address>
                                    </Box>
                                } 
                                {shopDest &&
                                    <Box p={2} style={{ borderRadius: "5px", background:"#99999945"}}>
                                        <Typography variant="caption">Destinataire : </Typography>
                                        <Typography variant="body1"><b>{shopDest.name}</b></Typography>
                                        <address>
                                            <Typography variant="body2">{shopDest.address}</Typography>
                                            <Typography variant="body2">{shopDest.city}</Typography>
                                            <Typography variant="body2">{shopDest.country}</Typography>
                                        </address>
                                    </Box>
                                } 
                                {transfer.nature == "commercial_return" && shop &&
                                    <Box p={2} style={{ borderRadius: "5px", background:"#99999945"}}>
                                        {/* {shop.logo &&
                                        <Box className="logo">
                                            <img src={`/stocks/photos/${shop.logo.filename}`} alt=""/>
                                        </Box>
                                        } */}
                                        <Box>
                                            <Typography variant="body1"><b>{shop.name}</b></Typography>
                                            {shop.tel && <Typography variant="body2">{shop.tel} </Typography> }
                                            {shop.email && <Typography variant="body2">{shop.email} </Typography> }
                                            <Typography variant="body2">{shop.address}</Typography>
                                            <Typography variant="body2">{shop.city} - {shop.country}</Typography>
                                        </Box>
                                    </Box>
                                    
                                } 
                                {commercial && transfer.nature != "commercial_return" && 
                                    <Box p={2} style={{ borderRadius: "5px", background:"#99999945"}}>
                                        <Typography variant="caption">Commercial : </Typography>
                                        <address>
                                            <Typography variant="body1"><b>{commercial.name}</b></Typography>
                                            <Typography variant="body2">{commercial.phone && commercial.phone.join(" - ")}</Typography>
                                            <Typography variant="body2">{commercial.email}</Typography>
                                        </address>
                                    </Box>
                                }
                            {/* </Grid>
                        </Grid> */}
                    </Box>
                    <div style={{clear: "both"}}></div>
                    {transfer.transfer_type === "resa" &&
                        <Box>
                            <Typography variant="subtitle">Réservation n° {transfer.id}</Typography><br />
                            <Typography variant="subtitle">
                                Date d'utilisation prévue : {(new Date(transfer.usage_date)).toLocaleDateString('fr-FR')}
                            </Typography>
                            <hr/>
                            <Alert severity="info">
                                {transfer.comments}
                            </Alert>
                            <hr/>
                        </Box>
                    }
                    {transfer.transfer_type === "install" &&
                        <Box>
                            <Typography variant="subtitle">Installation n° {transfer.id}</Typography><br />
                            <Typography variant="subtitle">
                                Date d'installation prévue : {(new Date(transfer.usage_date)).toLocaleDateString('fr-FR')}
                            </Typography>
                            <hr/>
                            <Alert severity="info">
                                {transfer.comments}
                            </Alert>
                            <hr/>
                        </Box>
                    }
                    {(transfer.transfer_type !== "install" && transfer.transfer_type !== "resa") &&
                        <Box>
                            {transfer.nature === "achat" &&
                                <Box p={1} style={{textAlign: 'right'}}><Typography variant="h6"><b>Achat {transfer.is_imported ? "Externe" : "Interne"}</b></Typography></Box>
                            }
                            {transfer.nature === "reapprovisionnement_ext" &&
                                <Box p={1} style={{textAlign: 'right'}}><Typography variant="h6"><b>Reappro Externe</b></Typography></Box>
                            }
                            {(transfer.nature === "demande" || transfer.nature === "arrivage") &&
                                <Box p={2} style={{textAlign: 'right'}}>
                                    <Typography variant="h6"><b>{transfer.nature.toUpperCase()}</b></Typography>
                                    <b>{transfer.user_name}</b>
                                </Box>
                            }
                            <Box p={1}>
                                {props.BL ?
                                    <Typography variant="subtitle"><b>Bon de Livraison  n° {transfer.intern_ref_id || transfer.id}</b></Typography>
                                    :
                                    <>
                                    {transfer.intern_ref_id ?
                                        <>
                                            <Typography variant="caption"><i>ID : {transfer.id}</i></Typography>
                                            <br />
                                            <Typography variant="button"><b>{transfer.intern_ref_id.startsWith("AV")?"Avoir n°":"Facture n°"} {transfer.intern_ref_id}</b></Typography>
                                        </>
                                        :
                                        <Typography variant="subtitle"><b>{(transfer.nature === "quote") ? "Devis":"Facture"} n° {transfer.id}</b></Typography>
                                    }
                                    </>
                                }                                
                                <br />
                                <Typography variant="button">
                                    Date :  {(new Date(transfer.creation_date)).toLocaleString('fr-FR')}
                                </Typography>
                                <br />
                                {(transfer.nature === "demande" || transfer.nature === "arrivage") &&
                                <Typography variant="body2">
                                    <i>Date d'arrivée {transfer.nature === "arrivage"? "prévue" : "souhaitée"} :  {(new Date(transfer.estimate_arrival_date)).toLocaleDateString('fr-FR')}</i>
                                </Typography>                                
                                }
                                {transfer.nature === "arrivage" &&
                                <Typography variant="body1" color="secondary">
                                    <b>Date d'arrivée réelle :  {(new Date(transfer.arrival_date)).toLocaleDateString('fr-FR')}</b>
                                </Typography>
                                }
                            </Box>
                            <br/>
                            {transfer.comments &&
                                <Alert color="warning" severity="info">
                                    <AlertTitle>{transfer.comments}</AlertTitle>
                                    {/* <Typography>Reste à payer: {<Currency value={rest} />}</Typography> */}
                                </Alert>
                            }
                            {/* {transfer.sale_credit &&
                                <Alert severity="info">
                                    <AlertTitle>{transfer.comments}</AlertTitle>
                                    <Typography>Reste à payer: {<Currency value={rest} />}</Typography>
                                </Alert>
                            } */}
                            <br/>
                        </Box>
                    }
                    <Box style={{ border: "1px dashed lightgray"}}>
                        <Box m={1} p={1} style={{ minHeight: "450px"}}>
                            {props.children}
                        </Box>
                    </Box>
                </Box>
                
            </div>
        </>
    );
}


export default SingleTransferBody;
